/* unplugin-vue-components disabled */import script from "./ChatContent.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatContent.vue?vue&type=script&setup=true&lang=js"

import "./ChatContent.vue?vue&type=style&index=0&id=ff144d1c&lang=css"
import "./ChatContent.vue?vue&type=style&index=1&id=ff144d1c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ff144d1c"]])

export default __exports__